import { Component, Inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent]
})
export class AppComponent {
  title = 'Verlanglijst.online';
}

@Component({
  selector: 'app-snackbar-component',
  templateUrl: 'app-snackbar.component.html',
  standalone: true
})
export class SnackbarComponent {
constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) { }
}

@Component({
  selector: 'app-snackbar-component-success',
  templateUrl: 'app-snackbar-success.component.html',
  standalone: true
})
export class SnackbarSuccessComponent {
constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) { }
}

@Component({
  selector: 'app-snackbar-component-error',
  templateUrl: 'app-snackbar-error.component.html',
  standalone: true
})
export class SnackbarErrorComponent {
constructor(@Inject(MAT_SNACK_BAR_DATA) public data: string) { }
}